export default "__VITE_ASSET__C1xMyc9G__"